<template>
  <div>
    <v-card-title>
      <h2>Reports</h2>
      <v-spacer/>
      <v-btn
        dark
        color="blue"
        round
        :to="{name: 'CreateReport'}"
      >
        <v-icon
          dark
          left
        >
          mdi-plus
        </v-icon>
        New Report
      </v-btn>
    </v-card-title>
    <v-alert
      :value="true"
      type="info"
      icon="mdi-run-fast"
    >
      <b>Report Improvements</b><br />
      Form Data Reports have been refactored, and now take significantly less time to generate.
    </v-alert>
    <br />
    <v-layout
      row wrap
    >
      <v-flex
        md12
      >
        <v-card>
          <v-data-table
            :items="templates"
            :pagination.sync="pagination"
            :total-items="totalReports"
            :rows-per-page-items="paginationStrings"
            :headers="headers"
            :loading="loading"
            disable-initial-sort
          >
            <template slot="no-data">
              <tr>
                <td colspan="5">
                  <div style="text-align:center;padding:25px;">
                    <v-icon size="125px">find_in_page</v-icon>
                    <h3>No Results</h3>
                  </div>
                </td>
              </tr>
            </template>
            <template
              slot="items"
              slot-scope="props"
            >
              <ReportRow
                :report="props.item"
                :key="props.item.id"
                @downloading="downloading = arguments[0]"
                @run="reportRequest = arguments[0];addReport = true"
              />
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="downloading"
      persistent
      width="300"
    >
      <v-card
        color="white"
      >
        <v-card-text>
          Requesting Report...<br/>
          <small>Just a moment</small>
          <v-progress-linear
            indeterminate
            color="blue"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import pagination from '@/components/global/pagination'
import ReportRow from '@/components/admin/reports/ReportRow'

export default {
  name: 'ReportList',
  props: [ 'settings' ],
  mixins: [
    pagination
  ],
  components: {
    ReportRow
  },
  data () {
    return {
      templates: [],
      addReport: false,
      reportRequest: null,
      pagination: {
        page: this.$route.query.page || 1,
        descending: this.$route.query.descending || false,
        rowsPerPage: this.$route.query.rowsPerPage || 10,
        sortBy: this.$route.query.sortBy || null
      },
      headers: [
        { text: 'Type', value: 'type', width: 150 },
        { text: 'Filter Conditions', value: 'filters' },
        { text: 'Requested', value: 'created_at', width: 175 },
        { text: 'Progress', value: 'progress', width: 300 },
        { text: '', value: '', width: 60 }
      ],
      defaultPagination: {
        page: 1,
        descending: false,
        rowsPerPage: 10,
        sortBy: null
      },
      searchText: this.$route.query.search || '',
      loading: true,
      paginationStrings: [
        10, 25, 50
      ],
      downloading: false
    }
  },
  computed: {
    totalReports () {
      return this.pagination.totalItems
    }
  },
  created () {
    this.documentTitle('Reports')
  },
  methods: {
    fetch () {
      this.loading = true
      api.reports.reports.list({
        search: this.searchText, ordering: (this.pagination.descending ? '-' : '') + this.pagination.sortBy, pageNum: this.pagination.page, count: this.pagination.rowsPerPage
      })
        .then(data => {
          this.templates = data.results
          this.pagination.totalItems = data.count
          this.pagination.page = data.page_number
          this.loading = false
          this.componentCreated = true
        })
    }
  }
}
</script>

<style>

table {
  table-layout: fixed;
}

.search-bar {
  margin-top: 1em;
}

table {
  margin-top: 1em;
}

.attention {
  background: rgba(0,0,0,0.1);
  padding: 3px;
  margin: 3px;
  border-radius: 3px;
  text-transform: capitalize;
}

.progress_text {
  position:absolute;
  left:10px;
  top:1px;
  width: 90%;
  z-index:2;
  color:white;
}

</style>
